<template>
  <!--客观题弹框 -->
  <div class="objectiove-dialog dialog">
    <el-dialog
      title="客观题"
      :visible="isShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
    >
      <el-form :inline="true" :model="formData" :rules="rulesFrom" ref="formData" class="demo-Form">
        <el-form-item label="大题号：" prop="tihao">
          <el-select v-model="formData.tihao" placeholder="请选择" style="width:100px;" size="small">
            <el-option v-for="item in stide" :key="'th'+item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目名称：" prop="timuName">
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="formData.timuName"
            maxlength="50"
            show-word-limit
            style="width:550px;"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item prop="tixing">
          <span slot="label" style="width:55px;text-align:left">题型：</span>
          <el-select
            v-model="formData.tixing"
            placeholder="请选择"
            style="width:100px;"
            size="small"
            @change="txChange"
          >
            <el-option :value="1" label="单选"></el-option>
            <el-option :value="2" label="多选"></el-option>
            <el-option :value="3" label="判断"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required>
          <span slot="label">题号：</span>
          <el-row class="input-pading-no">
            <el-col style="width:70px">
              <el-form-item prop="tihaoS">
                <el-input v-model="formData.tihaoS" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="dia-name" style="padding:0 10px;">至</el-col>
            <el-col style="width:70px">
              <el-form-item prop="tihaoE">
                <el-input v-model="formData.tihaoE" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="每题：" prop="fenshuo">
          <el-row class="input-pading-no">
            <el-col style="width:70px;">
              <el-input
                v-model="formData.fenshuo"
                size="small"
                type="number"
                :min="0.5"
                :step="0.5"
              ></el-input>
            </el-col>
            <el-col class="dia-name">分</el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="每题：" prop="xuanxiang">
          <el-row class="input-pading-no">
            <el-col style="width:70px;">
              <el-input
                v-model="formData.xuanxiang"
                size="small"
                type="number"
                :step="1"
                :min="1"
                :max="16"
                :disabled="formData.tixing==3"
              ></el-input>
            </el-col>
            <el-col class="dia-name">选项</el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="部分正解：" prop="bufen" v-if="formData.tixing==2">
          <el-row class="input-pading-no">
            <el-col style="width:70px;">
              <el-input v-model="formData.bufen" size="small" type="number" :min="0.5" :step="0.5"></el-input>
            </el-col>
            <el-col class="dia-name">分</el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            style="margin-left:15px;"
            @click="addTopic('formData')"
            circle
            size="mini"
          ></el-button>
        </el-form-item>
      </el-form>
      <div class="dialog-cont">
        <el-button type="text" @click="clearList(true)">清空列表</el-button>
        <div class="dialog-list">
          <el-table :data="formData.list" style="width: 100%">
            <el-table-column label="题号">
              <template slot-scope="scope">{{scope.row.tihao}}</template>
            </el-table-column>
            <el-table-column label="题型">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.tixing"
                  placeholder="请选择"
                  @change="tixingChange(scope)"
                  size="small"
                >
                  <el-option :value="1" label="单选"></el-option>
                  <el-option :value="2" label="多选"></el-option>
                  <el-option :value="3" label="判断"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="分值">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fenshuo" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="选项数">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.xuanxiang"
                  size="small"
                  :disabled="scope.row.tixing==3"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="部分得分">
              <template slot-scope="scope">
                <el-input v-model="scope.row.bufen" :disabled="scope.row.tixing!=2" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" style="text-align:center">
              <template slot-scope="scope">
                <el-button type="text" @click="clearList(false,scope)" icon="el-icon-delete"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align:right;padding-right:20px;">
        <el-button @click="dialogClose" :loading="loading">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="dialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//客观题
import { mapState, mapMutations } from "vuex";
import cardOperate from "@/assets/js/utils/cardOperate";
export default {
  name: "objective",
  //props: ["isShow", "isEdit", "allIndex"],
  props: ["isShow"],
  computed: {
    ...mapState("cardMake", {
      objectiveFrom: (state) => state.objectiveFrom, //
      topicStoreroom: (state) => state.topicStoreroom,
      answerSheet: (state) => state.answerSheet,
      topicTh: (state) => state.answerSheettopicTh,
      isBoxEdit: (state) => state.isBoxEdit,
      allIndex: (state) => state.allIndex,
    }),
  },

  data() {
    var tihaoR = (rule, value, callback) => {
      let validV = new RegExp("^([1-9]\\d{0,}\\.){0,2}[1-9]\\d{0,}$");
      if (!value) {
        callback(new Error("必填"));
      } else if (!validV.test(value)) {
        callback(new Error("请正确填写"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      formData: {
        tihao: "",
        timuName: "选择题",
        tixing: "",
        tihaoS: "",
        tihaoE: "",
        fenshuo: "",
        xuanxiang: 4,
        bufen: "",
        list: [],
        fsTotal: 0, //总分
        groupHArry: [],
        rowNum: 5, //一组默认5题显示
        diffLayout: false, //横竖排
        dingwei: null, //定位
      },
      stide: [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
      ], //tihao
      rulesFrom: {
        tihao: [{ required: true, message: "必填", trigger: "blur" }],
        timuName: [{ required: true, message: "必填", trigger: "blur" }],
        tixing: [{ required: true, message: "必填", trigger: "blur" }],
        tihaoS: [{ validator: tihaoR, trigger: "blur" }],
        tihaoE: [{ validator: tihaoR, trigger: "blur" }],
        fenshuo: [{ required: true, message: "必填", trigger: "blur" }],
        xuanxiang: [{ required: true, message: "必填", trigger: "blur" }],
        bufen: [{ required: true, message: "必填", trigger: "blur" }],
      },
      topicThMove: {
        isAdd: false,
        bigTh: [],
        smallTh: [],
      },
    };
  },
  created() {
    this.loading = true;
    if (this.isBoxEdit) {
      this.objectiveFromMut(
        this.topicStoreroom[this.allIndex.topicIndex].typesItem
      );
    }
    this.formData = JSON.parse(JSON.stringify(this.objectiveFrom));
  },
  mounted() {
    console.log(this.formData, "objectiveBox");
    this.$nextTick(function () {
      this.loading = false;
    });
  },
  methods: {
    ...mapMutations({
      objectiveFromMut: "cardMake/objectiveFromMut",
      topicThMut: "cardMake/topicThMut",
      objectiveDVMut: "cardMake/objectiveDVMut",
      isBoxEditMut: "cardMake/isBoxEditMut",
      allIndexMut: "cardMake/allIndexMut",
    }), //参数的变动
    txChange(v) {
      if (this.formData.tixing == 3) {
        this.formData.xuanxiang = 2;
      }
    },

    addTopic(formName) {
      this.loading = true;
      let self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let s = this.formData.tihaoS.split("."),
            e = this.formData.tihaoE.split(".");
          let isV = true;
          if (
            s.length != e.length ||
            (e.length == 2 &&
              this.formData.tihaoS.slice(0, 1) !=
                this.formData.tihaoE.slice(0, 1)) ||
            (e.length == 3 &&
              this.formData.tihaoS.slice(0, 3) !=
                this.formData.tihaoE.slice(0, 3)) ||
            parseInt(s[s.length - 1]) > parseInt(e[e.length - 1]) ||
            s.length > 3 ||
            e.length > 3
          ) {
            isV = false;
          }

          if (!isV) {
            this.$message({
              message: "开始题号和结束题号不正确",
              type: "warning",
            });
            this.loading = false;
            return;
          }
          let chazhi = e[e.length - 1] - s[s.length - 1];
          let curList = [];
          if (chazhi > 150) {
            this.$message({
              message: "最大只能添加150题",
              type: "warning",
            });
            this.loading = false;
            return;
          }
          for (let v = 0; v < chazhi + 1; v++) {
            let th = parseInt(s[s.length - 1]) + v;
            if (s.length > 1) {
              if (s.length - 2 == 0) {
                th = this.formData.tihaoS.slice(0, 1) + "." + th;
              } else {
                th = this.formData.tihaoS.slice(0, 3) + "." + th;
              }
            }
            this.formData.list.forEach((o) => {
              if (th == o.tihao) {
                isV = false;
                return;
              }
            });
            if (!isV) {
              this.$message({
                message: "本题设置的小题号已经存在",
                type: "warning",
              });

              this.loading = false;

              return;
            }
            let curD = {
              tihao: th,
              tixing: this.formData.tixing,
              fenzhi: this.formData.fenzhi,
              fenshuo: this.formData.fenshuo,
              xuanxiang: this.formData.xuanxiang,
              bufen: this.formData.bufen,
              tihaoWH: this.answerSheet.acCardABSet
                ? 18
                : 24 + (s.length - 1) * 10,
            };
            curList.push(curD);
          }

          let th = {
            isEdit: this.isBoxEdit,
            bigTh: this.formData.tihao,
            smallTh: [],
          };
          curList.forEach((t) => {
            th.smallTh.push(t.tihao);
          });
          cardOperate.topicRepeat(th).then((d) => {
            if (d) {
              let zhList = this.formData.list.concat(curList);
              this.formData.list = zhList.sort((a, b) => {
                return a.tihao - b.tihao;
              });
            }
          });
        } else {
          console.log("error submit!!");
        }

        //this.loading = false;
        setTimeout(function () {
          self.$nextTick(function () {
            self.loading = false;
          });
        }, 0);
      });
    }, //添加小题
    tixingChange(row) {
      console.log(row, "row");
      if (row.row.tixing == 3) {
        row.row.xuanxiang = 2;
      }
    }, //
    clearList(isAll, scope) {
      console.log(isAll, scope, "scope");
      if (this.isBoxEdit) {
        if (isAll) {
          let th = {
            isAdd: false,
            bigTh: this.formData.tihao,
            smallTh: [],
          };
          this.topicThMove.bigTh.push(th.bigTh);
          this.formData.list.forEach((t) => {
            th.smallTh.push(t.tihao);
            this.topicThMove.smallTh.push(t.tihao);
          });
          this.topicThMut(th);
          this.formData.list = [];
          this.formData.tihaoS = "";
          this.formData.tihaoE = "";
        } else {
          let th = {
            isAdd: false,
            bigTh: "",
            smallTh: [scope.row.tihao],
          };
          if (this.formData.list.length == 1) {
            th.bigTh = this.formData.tihao;
            this.topicThMove.bigTh.push(this.formData.tihao);
            this.formData.tihaoS = "";
            this.formData.tihaoE = "";
          }
          this.topicThMove.smallTh.push(scope.row.tihao);
          this.topicThMut(th);
          this.formData.list.splice(scope.$index, 1);
          if (this.formData.list.length > 1) {
            this.formData.tihaoS = this.formData.list[0].tihao;
            this.formData.tihaoE = this.formData.list[
              this.formData.list.length - 1
            ].tihao;
          } else if (this.formData.list.length == 1) {
            this.formData.tihaoS = this.formData.list[0].tihao;
            this.formData.tihaoE = "";
          }
        }
      } else {
        if (isAll) {
          this.formData.list = [];
        } else {
          this.formData.list.splice(scope.$index, 1);
        }
      }
    }, //清空列表
    dialogClose() {
      //this.$emit("update:isShow", false); //触发 input 事件，并传入新值
      this.objectiveDVMut(false);
      if (
        this.topicThMove.bigTh.length > 0 ||
        this.topicThMove.smallTh.length > 0
      ) {
        this.topicThMut(this.topicThMove);
        this.topicThMove.bigTh = [];
        this.topicThMove.smallTh = [];
      }
      this.objectiveFromMut({});
    },
    dialogSubmit() {
      if (this.formData.list.length > 0) {
        //计算宽高s
        let wTotal, //总宽
          hTotal = 0, //总高
          blockW = 0, //一组宽度
          blockH = 0, //一组高度
          rowNumStart = 0; //一行显行的个数记录,从哪个起点开始下一行,下一行开始的list节点
        let curGroupArry = []; //每行的高度值
        let groupArryNum = []; //每组对应该显示的个数{rowNum:一行显示几组，rowH:一行的高度，htmlCont:[]一个块点一个位置}
        if (this.answerSheet.acCardPanes != 3) {
          wTotal = 706 - 2 - 20 - 2 - 30; //（总宽-边框-边框padding-边框-内边距padding）
        } else {
          wTotal = 505 - 2 - 20 - 2 - 30;
        }
        if (this.formData.diffLayout) {
          //此时是B卷客观题坚排
          console.log(0);
          let curHarry = [];
          curHarry.length = Math.ceil(
            this.formData.list.length / this.formData.rowNum
          );
          for (let l = 0; l < curHarry.length; l++) {
            curHarry[l] = 0;
            this.formData.list
              .slice(l * this.formData.rowNum, (l + 1) * this.formData.rowNum)
              .forEach((t, i) => {
                //let curH = (parseInt(t.xuanxiang) + 1) * 18;
                let curH = t.tihaoWH + parseInt(t.xuanxiang) * 18;
                if (curHarry[l] < curH) {
                  curHarry[l] = curH;
                }
              });
          } //每组的高度值计算
          if (this.formData.list.length >= this.formData.rowNum) {
            blockW = 24 * this.formData.rowNum + 30;
          } else {
            blockW = this.formData.list.length * 24 + 30;
          } //一每宽度值

          let blockTotalW = 0;

          for (let whI = 0; whI < curHarry.length; whI++) {
            //debugger;
            blockTotalW = blockW * (whI - rowNumStart);
            let wh = curHarry[whI];
            if (
              whI - rowNumStart == 0 ||
              (whI - rowNumStart != 0 && blockH < wh)
            ) {
              blockH = wh;
            }
            if (wTotal - blockTotalW < blockW && whI < curHarry.length - 1) {
              let gA = {
                rowNum: whI - rowNumStart, //一行显示几组，
                rowH: blockH + 20, //一行的高度，
                htmlCont: [], //一个块点一个位置
              };
              curGroupArry.push(gA);
              blockTotalW = 0;
              blockH = 0;
              rowNumStart = whI;
              if ([blockW * (curHarry.length - 1 - whI)] <= wTotal) {
                let sliceArray = curHarry.slice(whI + 1);
                function compare(val1, val2) {
                  return val1 - val2;
                }
                sliceArray.sort(compare);
                let gA = {
                  rowNum: curHarry.length - whI, //一行显示几组，
                  rowH: sliceArray[sliceArray.length - 1] + 20, //一行的高度，
                  htmlCont: [], //一个块点一个位置
                };
                curGroupArry.push(gA);
                break;
              }
            } else if (
              wTotal - blockTotalW >= 0 &&
              whI == curHarry.length - 1
            ) {
              let gA = {
                rowNum: whI, //一行显示几组，
                rowH: blockH + 20, //一行的高度，
                htmlCont: [], //一个块点一个位置
              };
              curGroupArry.push(gA);
            }
          }

          curGroupArry.forEach((ga) => {
            hTotal += ga.rowH;
          });
          hTotal = hTotal + 20 + 2 + 40 + 10; //(自身总高+外框padding20+外框边框2+标题40+整框margin-top10)
          console.log(curHarry, blockH, curGroupArry, hTotal, "wh0");
        } else {
          //A卷横排
          let curWarry = []; //每块宽度的集合
          curWarry.length = Math.ceil(
            this.formData.list.length / this.formData.rowNum
          );
          for (let l = 0; l < curWarry.length; l++) {
            curWarry[l] = 0;
            this.formData.list
              .slice(l * this.formData.rowNum, (l + 1) * this.formData.rowNum)
              .forEach((t, i) => {
                //let curW = (parseInt(t.xuanxiang) + 1) * 24 + 30;
                let curW = t.tihaoWH + parseInt(t.xuanxiang) * 24 + 30;
                if (curWarry[l] < curW) {
                  curWarry[l] = curW;
                }
              });
          } //得出每块的宽度
          if (this.formData.list.length >= this.formData.rowNum) {
            //20为margin-top
            blockH = this.formData.rowNum * 18 + 20;
          } else {
            blockH = this.formData.list.length * 18 + 20;
            // hTotal = this.formData.list.length * 18 + 20;
          } //每一组高度值

          //curGroupArry.push(hTotal)
          console.log(curWarry, hTotal, "1");
          for (let whI = 0; whI < curWarry.length; whI++) {
            let wh = curWarry[whI];
            blockW += wh;
            if (wTotal - blockW < wh && whI < curWarry.length - 1) {
              hTotal += blockH;
              blockW = 0;
              let gA = {
                groupNum: rowNumStart == 0 ? whI + 1 : whI - rowNumStart, //一行显示几组，
                rowH: blockH, //一行的高度，
                htmlCont: [], //一个块点一个位置
              };
              curGroupArry.push(gA);
              rowNumStart = whI;
              let sliceArray = curWarry.slice(whI + 1);
              let curW = 0;
              sliceArray.forEach((a) => {
                curW += a;
              });
              console.log(sliceArray, curW, wTotal, hTotal, "2");
              if (curW <= wTotal) {
                function compare(val1, val2) {
                  return val1 - val2;
                }
                sliceArray.sort(compare);
                let gA = {
                  groupNum: sliceArray.length, //一行显示几组，
                  rowH: blockH, //一行的高度，
                  htmlCont: [], //一个块点一个位置
                };
                curGroupArry.push(gA);
                hTotal += blockH;
                console.log(sliceArray, curW, wTotal, hTotal, "3");
                break;
              }
            } else if (wTotal - blockW >= 0 && whI == curWarry.length - 1) {
              hTotal += blockH;
              blockW = 0;
              let gA = {
                groupNum: curWarry.length, //一行显示几组，
                rowH: blockH, //一行的高度，
                htmlCont: [], //一个块点一个位置
              };
              curGroupArry.push(gA);
            }
          }
          hTotal = hTotal + 20 + 2 + 40 + 10; //(自身总高+外框padding20+外框边框2+标题40+整框margin-top10)
          console.log(curWarry, blockH, wTotal, hTotal, "wh");
        }
        //计算宽高e

        let th = {
          bigTh: this.formData.tihao,
          smallTh: [],
        };
        let fsTotal = 0;
        try {
          this.formData.list.forEach((t) => {
            th.smallTh.push(t.tihao);
            fsTotal += parseFloat(t.fenshuo);
            if (!t.fenshuo) {
              throw new Error(`请正确填写第${t.tihao}题分数`);
            }
            if (!t.xuanxiang) {
              throw new Error(`请正确填写第${t.tihao}题选项`);
            }
          });
        } catch (e) {
          console.log(e, "eee");
          this.$message({
            message: e.message,
            type: "warning",
          });
          return;
        }
        this.formData.fsTotal = fsTotal;
        this.formData.groupHArry = curGroupArry;
        this.objectiveFromMut(this.formData);
        cardOperate
          .operateAddTopic({
            topicTypes: 1,
            h: hTotal,
            groupHArry: curGroupArry,
            th: th,
            isEdit: this.isBoxEdit,
            allIndex: this.allIndex,
            formD: JSON.parse(JSON.stringify(this.formData)),
          })
          .then((d) => {
            if (d) {
              this.dialogClose();
            }
          });
      } else {
        this.$message({
          message: "请设置题目",
          type: "warning",
        });
      }
    }, //确定大型设置完成
  },
  watch: {
    "$store.state.cardMake.objectiveDV": function (newV, oldV) {
      console.log("objectiveShow");
      if (this.isBoxEdit) {
        this.$set(
          this,
          "formData",
          this.topicStoreroom[this.allIndex.topicIndex].typesItem
        );
      } else {
        this.$set(
          this,
          "formData",
          JSON.parse(JSON.stringify(this.objectiveFrom))
        );
      }

      this.$nextTick(function () {
        this.loading = false;
      });
      // let self = this;
      // setTimeout(function() {
      //   console.log(newV, oldV, "watch");
      //   self.$set(self, "formData", newV);
      //   self.$nextTick(function() {
      //     self.loading = false;
      //   });
      // }, 1000);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
